module.exports = __webpack_public_path__ + "static/media/lion-watercolor.c662fb65.png";